import React, { useState, useRef, useEffect } from 'react';

import Localization from '../../Localization';
import AutoSuggest from 'react-autosuggest';
import useOnClickOutside from 'use-onclickoutside';

import './styles.scss';

const renderSuggestion = suggestion => (
  <div>
    {suggestion}
  </div>
);

const renderSuggestionZH = suggestion => (
  <div>
    {Localization.get(suggestion.toUpperCase())}
  </div>
);

const startsWith = (word, prefix) => {
  const wordLower = word.toLowerCase()
  const prefixLower = prefix.toLowerCase()
  const prefixLength = prefixLower.length;
  return wordLower.substr(0, prefixLength) === prefixLower
}

const countrySortWithValue = (value) => {
  return (a, b) => {
    if (a === 'ALL') {
      return -1
    }
    if (b === 'ALL') {
      return 1
    }
    if (value !== '' && value !== null) {
      const aStartsWith = startsWith(a, value)
      const bStartsWith = startsWith(b, value)
      if (aStartsWith && !bStartsWith) {
        return -1
      }
      if (!aStartsWith && bStartsWith) {
        return 1
      }
    }

    if (a > b) {
      return 1
    }
    return -1
  }
}
export default function CountrySelect(props) {
  const { countries, value, language } = props;

  const [selectOpen, setSelectOpen] = useState(false)
  const [currentTypedInputValue, setCurrentTypedInputValue] = useState('')
  const [currentSuggestions, setCurrentSuggestions] = useState(null)
  const containerRef = useRef()
  const inputRef = useRef()

  useEffect(() => {
    if (selectOpen) {
      inputRef.current && inputRef.current.focus()
      setCurrentTypedInputValue('')
      setCurrentSuggestions(null)
    }
  }, [selectOpen])

  const close = () => {
    setSelectOpen(false)
    clear();
  }
  useOnClickOutside(containerRef, close)

  const onChangeTypeEntry = (event, {newValue}) => {
    setCurrentTypedInputValue(newValue)
  }

  const fetchSuggestions = ({value}) => {
    const input = value.toLowerCase()
    const suggestions = countries.filter(
      country => (
        country.toLowerCase().includes(input)
          ||
        Localization.get(country.toUpperCase(), false, 'zh').toLowerCase().includes(input)
      )
    ).sort(countrySortWithValue(value))
    setCurrentSuggestions(suggestions)
  }

  const pickSelection = (event, { suggestion, suggestionValue }) => {
    close()
    props.onChange(suggestion)
  }

  const highlightSelection = ({ suggestion }) => props.onHighlight(suggestion);

  const toggleSelectOpen = (event) => {
    if (selectOpen) {
      close()
    } else {
      setSelectOpen(true)
    }
  }

  const clear = () => {
    inputRef.current && inputRef.current.focus()
    setCurrentTypedInputValue('')
    setCurrentSuggestions(null)
    inputRef.current && inputRef.current.focus()
  }

  const onClearButton = () => {
    props.onClear();
    clear();
  }

  const renderInput = (props) => {
    const clearButton = props.value === '' ? null : <span className='closeButton' onClick={onClearButton}>&times;</span>
    return (
      <div className='customInput'>
        <input {...props} ref={inputRef} />
        {clearButton}
      </div>
    )
  }

  const autoselect = selectOpen ? (
    <AutoSuggest
      suggestions={currentSuggestions || countries}
      onSuggestionsFetchRequested={fetchSuggestions}
      getSuggestionValue={country => country}
      renderSuggestion={language === 'zh' ? renderSuggestionZH : renderSuggestion}
      inputProps={{
        value: currentTypedInputValue,
        onChange: onChangeTypeEntry,
      }}
      alwaysRenderSuggestions={true}
      onSuggestionSelected={pickSelection}
      onSuggestionHighlighted={highlightSelection}
      renderInputComponent={renderInput}
      focusInputOnSuggestionClick={false}
    />
  ) : null

  const activeValue = value === '' ? 'ALL' : value;
  const displayValue = language === 'zh' ? Localization.get(activeValue.toUpperCase()) : activeValue;

  return (
    <div className={`countrySelect ${selectOpen ? 'open' : ''}`} style={props.style} ref={containerRef}>
      <div className='countrySelectLabel' onClick={toggleSelectOpen}>
        {displayValue}
      </div>
      {autoselect}
    </div>
  )
}

CountrySelect.defaultProps = {
  onChange: () => {},
  onHighlight: () => {},
  onClear: () => {},
};
